<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar data de vencimento das mensalidades da cobrança
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Id</th>
                <td>{{ contract.id }}</td>
              </tr>
              <tr>
                <th>Instituição</th>
                <td>{{ contract.institution_name }}</td>
              </tr>
              <tr>
                <th>Nome do curso</th>
                <td>{{ contract.course_name }}</td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <div>
              <p>
                Nova data para as mensalidades:
              </p>
              <select v-model="selectedDay" @click="inputError = null" class="form-control">
                <option v-for="day in days" :key="day" :value="day">
                  {{ day }}
                </option>
              </select>
            </div>
            <p class="modal-legend">
              Essa ação afetará o dia de vencimento <strong>todas</strong> as mensalidades desse contrato
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="changeBillDueDate">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ContractsService from 'services/ContractsService';

export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedDay: null,
      inputError: null,
    };
  },
  computed: {
    days() {
      return this.contract.available_due_days;
    },
  },
  methods: {
    ...mapActions([
      'loadStudentContracts',
      'loadStudentBills',
    ]),
    validateSelectedDay() {
      if (this.selectedDay === null) {
        this.inputError = 'Um dia deve ser selecionado';
        return false;
      }
      return true;
    },
    changeBillDueDate() {
      if (!this.validateSelectedDay()) {
        return;
      }
      this.$loader.show();
      ContractsService.updateContractBillsDueDate(this.contract.id, this.selectedDay)
        .then(() => {
          this.$loader.hide();
          this.$emit('close');
          this.loadStudentContracts().then(() => this.loadStudentBills());
          this.$alert.notifySuccess('Alteração efetuada com sucesso');
        })
        .catch(() => {
          this.$loader.hide();
          this.inputError = 'Erro ao alterar o dia de vencimento';
        });
    },
  },
};
</script>
